{
  "version": 1,
  "asset_id": "02b42f58-5325-4968-9c8d-0876897a6c4e",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/02b42f58-5325-4968-9c8d-0876897a6c4e/battery-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/02b42f58-5325-4968-9c8d-0876897a6c4e/battery-card.webp",
  "original_filename": "battery-card.webp",
  "size": 10888,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:24:41Z"
}
